module.exports = __webpack_public_path__ + "static/img/img_3.ad838e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_3.png
// module id = pTH5
// module chunks = 1